(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
    .directive('personEntry', ['$q', '$timeout', '$rootScope', '$translate', 'SourceConstant', 'DocumentStateService', 'AppConstants', 
        'ResourceService', 'MessageManager', 'MessageProvider', 'ClientMetricsService', 'UserService', 'FeatureManagerService', 
        'Features', 'ModalFactory', 'SignalProvider', 'OrganizationService', '$log',
        function ($q, $timeout, $rootScope, $translate, SourceConstant, DocumentStateService, AppConstants, ResourceService, 
            MessageManager, MessageProvider, ClientMetricsService, UserService, FeatureManagerService, Features, 
            ModalFactory, SignalProvider, OrganizationService, $log) {

            // AppConstant bindings
            var collaboratorTypes = AppConstants.CollaboratorTypes,
                globalRoles = AppConstants.GlobalRoles,
                rolyTypes = AppConstants.RoleTypes,
                METRICS_EVENTS = {
                    USER_PRINCIPAL_ROLE_CHANGE: {name: 'USER_PRINCIPAL_ROLE_CHANGE'},
                    GROUP_PRINCIPAL_ROLE_CHANGE: {name: 'GROUP_PRINCIPAL_ROLE_CHANGE'},
                    ANONYMOUS_PRINCIPAL_ROLE_CHANGE: {name: 'ANONYMOUS_PRINCIPAL_ROLE_CHANGE'}
                },
                SHARE_RESULT = {
                    FEEDBACK_FAILURE: 'FAILED',
                    SHARE_FAILURE: 'FAILURE'
                },
                FAILED_TO_INVITE_COOWNER_TO_MINIMALUSER = 'Failed to invite new minimal user for role COOWNER',
                FAILED_TO_INVITE_CONTRIBUTOR_TO_MINIMALUSER = 'Failed to invite new minimal user for role CONTRIBUTOR',
                FAILED_TO_SHARE_TO_MINIMALUSER = 'Minimal user can only have Viewer permissions.';

            function roleToHumanString (role) {
                switch (role) {
                    case globalRoles.CONTRIBUTOR:
                        return $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                    case globalRoles.COOWNER:
                        return $translate.instant('RIGHT_NAV.CO_OWNER');
                    case globalRoles.OWNER: 
                        return $translate.instant('RIGHT_NAV.OWNER');
                    default:
                        return $translate.instant('RIGHT_NAV.VIEWER');
                }
            }

            // Binds ("import") functions defined in scope.$parent into scope
            function bindParentScopeFunctions (scope, functionMap) {
                var key;

                for (key in functionMap) {
                    if (functionMap.hasOwnProperty(key)) {
                        scope[key] = scope.$parent[functionMap[key]];
                    }
                }
            }

            return {
                restrict: 'E',
                scope: {
                    person: '=',
                    role: '=type',
                    resourceInfo: '=',
                    deadline: '=',
                    request: '=',
                    comments: '=',
                    feedbackLoaded: '<',
                    inGroupView: '<',
                    roleType: '=',
                    showPermissionColumn: '<',
                    onPersonSelected: '&'
                },
                link: function (scope, element, attrs) {
                    scope.parentScope = scope.$parent;
                    scope.typeName = roleToHumanString(scope.role);
                    scope.isDirect = scope.roleType === rolyTypes.DIRECT;
                    scope.isInherited = scope.roleType === rolyTypes.INHERITED;
                    scope.isOwner = scope.role === globalRoles.OWNER;
                    scope.isReadOnly = scope.role === globalRoles.VIEWER;
                    scope.isUser = scope.person.Type === collaboratorTypes.USER;
                    scope.isGroup = scope.person.Type === collaboratorTypes.GROUP;
                    scope.isAnon = scope.person.Type === collaboratorTypes.ANONYMOUS;
                    scope.isDoc = DocumentStateService.contentType !== null;
                    scope.isMinimalUser = false;
                    scope.showPermissionColumn = scope.showPermissionColumn === undefined? true: scope.showPermissionColumn;
                    scope.viewerPermissionsOnly = isDocViewerPermissionsOnly(DocumentStateService.currentUserRoles);

                    // Explicitly "import" functions from parent scope.
                    // TODO: probably move those to something like DocumentUtilities but these functions currently rely
                    // on data stored in scope so it's not a 2-min change.
                    bindParentScopeFunctions(scope, {
                        isPersonSelected: 'isPersonSelected',
                        isGroupSelected: 'isGroupSelected',
                        inRecycleBin: 'inRecycleBin',
                        hasSharePermission: 'hasSharePermission',
                        hasRemoveUserFromSharePermission: 'hasRemoveUserFromSharePermission'
                    });

                    scope.GlobalRoles = globalRoles;

                    scope.checkMinimalUser = function () {
                        var done = $q.defer();

                        UserService.getUserById(scope.person.Id)
                        .then (function (response) {
                            var userInfo = response.data.User;
                            scope.isMinimalUser = FeatureManagerService.isFeatureEnabled(Features.UI.EXTERNAL_SHARE) && userInfo.MinimalUser;
                            done.resolve();
                        }, function (error) {
                            done.reject(error);
                        });

                        return done.promise;
                    };

                    scope.canRemoveUser = function () {
                        var canRemove;

                        if (scope.hasRemoveUserFromSharePermission) {
                            canRemove = scope.hasRemoveUserFromSharePermission();
                        } else {
                            canRemove = scope.hasSharePermission();
                        }

                        return canRemove && !scope.isOwner;
                    };

                    scope.getUserFullName = function(person) {
                        if (scope.isUser && scope.person.GivenName) {
                            return $translate.instant('RIGHT_NAV.PERSON_NAME', {
                                givenName: $rootScope.escapeHTML(person.GivenName),
                                surname: $rootScope.escapeHTML(person.Surname)
                            });
                        }
                        if (scope.isUser && !person.GivenName) {
                            return person.Username;
                        }
                        if (scope.isAnon) {
                            return person.Id;
                        }
                        if (scope.isGroup) {
                            return person.Name;
                        }
                    };

                    scope.showPermissionChange = function() {
                        if (!scope.hasSharePermission || !scope.hasSharePermission()) {
                            return false;
                        }
                        if (!scope.isOwner && !scope.inGroupView && scope.isDirect) {
                            return true;
                        }
                        return false;
                    };

                    scope.updateRole = function(person, type, resourceInfo) {
                        if (person === undefined || type === undefined || resourceInfo === undefined) {
                            return;
                        }
                        var done = $q.defer(),
                        promise = null;

                        var data = {
                            shareResourceId: resourceInfo.Id,
                            role: type,
                            collaborators: [person],
                            message: "",
                            feedbackRequested: false,
                            feedbackRequestList: [],
                            deadline: null
                        };

                        promise = changePermission(data, resourceInfo.resourceType);

                        promise.then(function success() {
                            MessageManager.addSuccessMessage(MessageProvider.allChangesDone, true);
                            done.resolve();
                        }, function error(errorObj) {
                            $log.error("Failed to update principal for user. ErrorObj: " + JSON.stringify(errorObj));
                            // Handle the case if the network is slow and co-owner & contributor options are not disabled immediately.
                            if (errorObj.Status === SHARE_RESULT.SHARE_FAILURE &&
                                (errorObj.StatusMessage === FAILED_TO_INVITE_COOWNER_TO_MINIMALUSER  ||
                                    errorObj.StatusMessage === FAILED_TO_INVITE_CONTRIBUTOR_TO_MINIMALUSER ||
                                    errorObj.StatusMessage === FAILED_TO_SHARE_TO_MINIMALUSER)) {
                                    MessageManager.addErrorMessage(MessageProvider.documentContributePermissionFailMinimalUser);
                            } else {
                                if (resourceInfo.resourceType == AppConstants.ResourceTypes.FILE) {
                                    MessageManager.addErrorMessage(MessageProvider.defaultShareFailure);
                                } else if (resourceInfo.resourceType == AppConstants.ResourceTypes.FOLDER) {
                                    MessageManager.addErrorMessage(MessageProvider.folderShareFailDefault);
                                }
                            }
                            done.reject();
                        });
                        if (person.Type === collaboratorTypes.USER) {
                            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.USER_PRINCIPAL_ROLE_CHANGE, 1);
                        } else if (person.Type === collaboratorTypes.GROUP) {
                            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.GROUP_PRINCIPAL_ROLE_CHANGE, 1);
                        } else {
                            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.ANONYMOUS_PRINCIPAL_ROLE_CHANGE, 1);
                        }
                        
                        return done.promise;
                    };

                    // Permissions
                    scope.showRemovePermission = function(resourceInfo, principalId, principalName) {
                        var title = $translate.instant('MODAL.DELETE_PERMISSION_MODAL.REMOVE_PERMISSION_TITLE'),
                            message = $translate.instant('MODAL.DELETE_PERMISSION_MODAL.REMOVE_PERMISSION_MESSAGE'),
                            okayButtonText = $translate.instant('GENERAL_LABELS.OK'),
                            cancelButtonText = $translate.instant('GENERAL_LABELS.CANCEL');
                        ModalFactory.showConfirmationModal(title, message, okayButtonText, cancelButtonText).then(function() {
                            scope.removePermission(resourceInfo.Id, principalId, principalName);
                        }, function() {
                            
                        });
                    };

                    scope.removePermission = function(resourceId, removePrincipalId, removePrincipalName) {
                        ResourceService.deleteResourcePermission(resourceId, removePrincipalId)
                        .success(function() {
                            if (removePrincipalName === OrganizationService.ORG_USER_USERNAME) {
                                MessageManager.addSuccessMessage(MessageProvider.folderGroupShareRemovalSuccess);
                            } else {
                                MessageManager.addSuccessMessage(MessageProvider.folderPermissionRemoveSuccess(removePrincipalName));
                            }
                            $rootScope.$broadcast(SignalProvider.Permission.PermissionUpdated);
                            $rootScope.$broadcast(SignalProvider.Permission.PrincipalRemoved);
                        });
                    };

                    function changePermission(data, resourceType) {
                        if (resourceType == AppConstants.ResourceTypes.FILE) {
                            return changeDocumentPermission(data);
                        } else if (resourceType == AppConstants.ResourceTypes.FOLDER) {
                            return changeFolderPermission(data);
                        }
                    }

                    function changeFolderPermission(data) {
                        var done = $q.defer();

                        if (!data) {
                            done.reject();
                            return done.promise;
                        }

                        ResourceService.addResourcePermissions(data.shareResourceId, data.role, data.collaborators, data.message).then(function(response) {
                            response = response.data ? response.data : response;
                            if (response && response.ShareResults) {
                                var allSharesSucceeded = true;
                                angular.forEach(response.ShareResults, function(value) {
                                    if (allSharesSucceeded && value.Status === SHARE_RESULT.SHARE_FAILURE) {
                                        allSharesSucceeded = false;
                                    }
                                    if (value.Status !== SHARE_RESULT.SHARE_FAILURE && scope.person.Id === value.PrincipalId) {
                                        updatePersonInfo(scope.person.Id, value.Role);
                                    }
                                });

                                if (!allSharesSucceeded) {
                                    done.reject({
                                        status: AppConstants.HttpStatuses.NOT_FOUND
                                    });
                                    return done.promise;
                                } else {
                                    // If all the shares are successful
                                    done.resolve();
                                }
                            }
                        }, function(error) {
                            done.reject(error);
                        });

                        return done.promise;
                    }

                    function changeDocumentPermission(data) {
                        if (!data) {
                            done.reject();
                            return;
                        }

                        var done = $q.defer();

                        if (data.collaborators.length > 0) {
                            ResourceService.addResourcePermissions(data.shareResourceId, data.role, data.collaborators, data.message).then(function success(response) {
                                response = response.data ? response.data : response;
                                if (response && response.ShareResults) {
                                    var allSharesSucceeded = true;
                                    var shareStatus, shareStatusMessage;
                                    angular.forEach(response.ShareResults, function(value) {
                                        if (allSharesSucceeded && value.Status === SHARE_RESULT.SHARE_FAILURE) {
                                            allSharesSucceeded = false;
                                            shareStatus = value.Status;
                                            shareStatusMessage = value.StatusMessage;
                                        }
                                        if (value.Status !== SHARE_RESULT.SHARE_FAILURE && scope.person.Id === value.PrincipalId) {
                                            updatePersonInfo(scope.person.Id, value.Role);
                                        }
                                    });

                                    if (!allSharesSucceeded) {
                                        done.reject({
                                            Status: shareStatus,
                                            StatusMessage: shareStatusMessage
                                        });
                                        return done.promise;
                                    } else {
                                        // If all the shares are successful
                                        done.resolve();
                                    }
                                }
                            }, function error(response) {
                                done.reject(response);
                            });
                        }

                        return done.promise;
                    }

                    function updatePersonInfo(Id, role) {
                        if (Id !== scope.person.Id) {
                            return;
                        }
                        scope.person.Role = role;
                        scope.role = role;
                        scope.typeName = roleToHumanString(scope.role);
                        scope.isOwner = scope.role === globalRoles.OWNER;
                        scope.isReadOnly = scope.role === globalRoles.VIEWER;
                    }

                    scope.$watch('person', function (newValue, oldValue) {
                        var feedbackUser;

                        // No need to go fetch the feedback color from the DocumentStateService if we already have one.
                        if (newValue !== oldValue && !newValue.color) {
                            feedbackUser = DocumentStateService.feedback.users[newValue.Id];

                            if (feedbackUser) {
                                newValue.color = feedbackUser.color;
                            }
                        }
                    });

                    function isDocViewerPermissionsOnly(currentUserRoles) {
                        if (currentUserRoles) {
                            for (var i = 0; i < currentUserRoles.length; i++) {
                                if (currentUserRoles[i].role !== globalRoles.VIEWER) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    }
                },
                templateUrl: './shared/person_entry.html'
            };
        }
    ]);
}());
